<template lang="pug">
  v-dialog(v-model="visible" hide-overlay persistent :width="width")
    v-card(color="primary" dark)
      v-card-text
        slot Пожалуйста, подождите...
        v-progress-linear.mb-0(indeterminate color="white")
</template>

<script>
export default {
  name: 'app-dialog-loading',

  props: {
    show: Boolean,
    width: {
      type: [Number, String],
      default: 300
    }
  },

  model: {
    prop: 'show',
    event: 'updateShow'
  },

  computed: {
    visible: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('updateShow', value)
      }
    }
  }
}
</script>
